import makeStyles from '@mui/styles/makeStyles'

const bp = 'sm'

const useStyles = makeStyles(theme => ({
  taskInfo: {
    display: 'flex',
    marginTop: '9px',

    [theme.breakpoints.down(bp)]: {
      flexDirection: 'column'
    }
  },

  taskInfo2: {
    marginTop: '0',
    paddingBottom: '1rem',

    [theme.breakpoints.up('md')]: {
      marginTop: '-1rem'
    }
  },

  infoColumn1: {
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'column',
    flexBasis: '50%',
    padding: '1rem 0 0 0',
    color: 'grey',

    '& > div': {
      height: '35px',

      '& > span': {
        width: '175px',
        cursor: 'default',

        [theme.breakpoints.down(bp)]: {
          width: 'revert',
          marginRight: '0'
        }
      },

      [theme.breakpoints.down(bp)]: {
        height: 'auto'
      }
    },

    [theme.breakpoints.down(bp)]: {
      paddingTop: '1rem',
      fontSize: theme.size.sm
    }
  },

  infoColumn2: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '40%',
    padding: '1rem 0 0 0',
    color: 'grey',

    '& > div': {
      height: '35px',

      '& > span': {
        width: '175px',
        cursor: 'default',

        [theme.breakpoints.down(bp)]: {
          width: 'revert',
          marginRight: '0'
        }
      }
    },

    [theme.breakpoints.down(bp)]: {
      padding: '0',
      fontSize: theme.size.sm
    }
  },

  gridItem: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '35px',
    margin: '0.25rem 0'
  },

  center: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',

    '& > .MuiIconButton-root:hover': {
      backgroundColor: 'transparent'
    },

    '& > svg': {
      marginRight: '0.25rem'
    }
  },

  label: {
    marginRight: '0.5rem',

    '& > svg': {
      marginRight: '0.5rem',
      color: 'black'
    }
  },

  input: {
    width: '50%',

    [theme.breakpoints.down(bp)]: {
      width: '100%'
    },

    '& > div > div > div > div': {
      fontSize: theme.size.sm
    },

    '& > div > div > div > div > ::-webkit-input-placeholder': {
      color: '#7F8487',
      opacity: '1'
    },

    '& svg': {
      color: 'grey',
      width: '100%'
    },

    '& .MuiChip-deleteIcon': {
      width: '22px !important'
    },

    '& > div > #react-autowhatever-1 > ul > li > div': {
      fontSize: theme.size.sm
    },

    [theme.breakpoints.down(900)]: {
      '& > div > div > div > div': {
        fontSize: theme.size.sm
      }
    }
  },

  upInput: {
    [theme.breakpoints.down(bp)]: {
      marginTop: '14px !important'
    }
  },

  avatar: {
    margin: '0 10px 5px 0',
    width: theme.size.xl,
    height: theme.size.xl,
    fontSize: theme.size.sm,

    '& svg': {
      width: theme.size.xl,
      height: theme.size.xl
    }
  },

  dismiss: {
    position: 'relative',
    '&:hover': {
      '& svg.close': {
        display: 'block'
      }
    },
    '& svg.close': {
      cursor: 'pointer',
      position: 'absolute',
      zIndex: 10,
      bottom: '22px',
      left: '15px',
      color: 'white',
      borderRadius: '70px',
      display: 'none'
    }
  },

  noPermission: {
    cursor: 'default',
    opacity: '0.4'
  },

  name: {
    width: '150px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  alert: {
    marginRight: '8px',
    borderRadius: '50%',
    boxSizing: 'border-box',
    width: '10px',
    height: '10px'
  },

  transparent: {
    '& > div > div, & > div > div:focus, & > div > div > div > div > input': {
      border: 'none',
      backgroundColor: 'white',
      outline: 'none',
      paddingLeft: '0',
      marginBottom: '0'
    },

    '& > div > input': {
      border: 'none',
      backgroundColor: 'white',
      outline: 'none',
      paddingLeft: '0',
      width: '50%',

      [theme.breakpoints.down(bp)]: {
        width: '100%'
      }
    },

    '& > div > input:focus': {
      boxShadow: 'none',
      borderColor: 'none'
    }
  },

  tags: {
    margin: '0 0.25rem',
    padding: '0.25rem 0.5rem',
    backgroundColor: '#F1F1F1',
    color: 'grey',
    borderRadius: '0.75rem',
    border: '0.0625rem solid white',
    display: 'flex',
    alignItems: 'center'
  },

  mobile: {
    [theme.breakpoints.down(bp)]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      marginBottom: '2rem',
      flexBasis: '100%',
      position: 'relative',

      '& > :nth-child(2)': {
        marginTop: '1.5rem',
        width: '100%',
        position: 'absolute',
        flexWrap: 'wrap',
        maxHeight: '6svh'
      }
    }
  },

  assignedTo: {
    '& > :nth-child(2)': {
      [theme.breakpoints.down(bp)]: {
        overflowY: 'auto'
      }
    }
  },

  arrow: {
    margin: '1rem 0 1.5rem 0',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: theme.size.sm
  },

  top: {
    [theme.breakpoints.down(bp)]: {
      '& > div': {
        marginTop: '1rem'
      }
    }
  },

  bottom: {
    [theme.breakpoints.down(bp)]: {
      '& > div': {
        marginTop: '1rem'
      }
    }
  },

  chipAvatar: {
    '& .MuiAvatar-root': {
      width: theme.size.xl,
      height: theme.size.xl,
      fontSize: `${theme.size.sm} !important`
    }
  },

  container: {}
}))

export default useStyles
